import { useEffect, useState } from "react";
import { useSingleton } from "../../other/injection";
import { MessageBusService } from "../../other/messageBus/MessageBusService";
import styled from "@emotion/styled";
import { Accepted } from "../../uiLibrary/icons/Accepted";
import { Warning } from "../../uiLibrary/icons/Warning";
import { Declined } from "../../uiLibrary/icons/Declined";
import { level35 } from "../../other/theme/opacities";

const IconSize = 12;
type Result =
    | RedDeer.Contracts.Queries.SystemMonitor.GetSystemMonitorResultStatusResult
    | undefined;

const request: RedDeer.Contracts.Queries.SystemMonitor.GetSystemMonitorResultStatusQuery =
    {
        MessageType: "Queries.SystemMonitor.GetSystemMonitorResultStatusQuery"
    };

export function SystemMonitorResultStatus() {
    const messageBusService = useSingleton(MessageBusService);
    const [currentStatus, setCurrentStatus] = useState<Result>(undefined);

    useEffect(
        () =>
            messageBusService.asyncSubscribe<Result>({
                request,
                description: `Subscribing to System Monitors status`,
                callback: response => {
                    setCurrentStatus(response);
                }
            }),
        [messageBusService]
    );

    if (!currentStatus?.ShouldDisplay) {
        return <></>;
    }
    const status =
        currentStatus.Status ??
        RedDeer.Contracts.Enums.SystemMonitorStatus.Failed;

    const statusString =
        status === RedDeer.Contracts.Enums.SystemMonitorStatus.Failed
            ? "Failed,Warning"
            : RedDeer.Contracts.Enums.SystemMonitorStatus[status];

    return (
        <a
            href={`#/Search?lookBackDays=${currentStatus.LookBackDays?.toString() ?? ""}&systemMonitorStatuses=${statusString}`}
        >
            <DataStatusContainer curentStatus={status}>
                <span>Latest data</span>
                <SpacerDiv />
                {getIconForStatus(status)}
            </DataStatusContainer>
        </a>
    );
}

function getIconForStatus(
    curentStatus: RedDeer.Contracts.Enums.SystemMonitorStatus
) {
    if (curentStatus === RedDeer.Contracts.Enums.SystemMonitorStatus.Success) {
        return <Accepted size={IconSize} />;
    }

    if (curentStatus === RedDeer.Contracts.Enums.SystemMonitorStatus.Warning) {
        return <Warning size={IconSize} />;
    }
    return <Declined size={IconSize} />;
}

const DataStatusContainer = styled.div<{
    curentStatus: RedDeer.Contracts.Enums.SystemMonitorStatus;
}>(props => ({
    ...{
        padding: "4px 7px",
        minHeight: 30,
        fontSize: props.theme.fontSizes.small,
        display: "flex",
        alignItems: "center",
        gap: 4,
        flexDirection: "row",
        opacity: 0.8,
        "&:hover": {
            opacity: 1,
            backgroundColor: props.theme.brandMedium + level35
        }
    },
    ...(props.curentStatus ===
        RedDeer.Contracts.Enums.SystemMonitorStatus.Warning && {
        border: `1px solid ${props.theme.error}`
    }),
    ...(props.curentStatus ===
        RedDeer.Contracts.Enums.SystemMonitorStatus.Failed && {
        border: `1px solid ${props.theme.danger1}`
    })
}));

const SpacerDiv = styled.div({ marginLeft: "auto", marginRight: "auto" });
